export default __webpack_public_path__ + "static/media/master.d776a054.svg";